module.exports = __webpack_public_path__ + "static/media/stage_5.bb66bb93.png";